/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShopForMeRequest,
  NewShopForMeRequest,
  RoleMappingCount200Response,
} from '../models/index';
import {
    ShopForMeRequestFromJSON,
    ShopForMeRequestToJSON,
    NewShopForMeRequestFromJSON,
    NewShopForMeRequestToJSON,
    RoleMappingCount200ResponseFromJSON,
} from '../models/index';

export interface ShopForMeRequestCountRequest {
    where?: string;
}

export interface ShopForMeRequestCreateRequest {
    data?: NewShopForMeRequest;
}

export interface ShopForMeRequestDeleteByIdRequest {
    id: string;
}

export interface ShopForMeRequestFindRequest {
    filter?: string;
}

export interface ShopForMeRequestFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ShopForMeRequestPrototypePatchAttributesRequest {
    id: string;
    data?: ShopForMeRequest;
}

export interface ShopForMeRequestQuoteRequest {
    requestId: number;
    totalAmount: number;
    purchasingFee: number;
    adminNotes?: string;
}

export interface ShopForMeRequestConfirmQuoteRequest {
    id: string;
}

export interface ShopForMeRequestUploadProofRequest {
    id: string;
    proofOfPayment: string;
}

export interface ShopForMeRequestUpdateStatusRequest {
    requestId: number;
    status: string;
    packageId?: number;
    adminNotes?: string;
}

export interface ShopForMeRequestSendPaymentLinkRequest {
    requestId: number;
}

/**
 * 
 */
export class ShopForMeRequestApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async shopForMeRequestCountRaw(requestParameters: ShopForMeRequestCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeRequests/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async shopForMeRequestCount(requestParameters: ShopForMeRequestCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.shopForMeRequestCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopForMeRequestCreateRaw(requestParameters: ShopForMeRequestCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopForMeRequests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewShopForMeRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async shopForMeRequestCreate(requestParameters: ShopForMeRequestCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopForMeRequestDeleteByIdRaw(requestParameters: ShopForMeRequestDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeRequestDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async shopForMeRequestDeleteById(requestParameters: ShopForMeRequestDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shopForMeRequestDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopForMeRequestFindRaw(requestParameters: ShopForMeRequestFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShopForMeRequest>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeRequests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShopForMeRequestFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async shopForMeRequestFind(requestParameters: ShopForMeRequestFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShopForMeRequest>> {
        const response = await this.shopForMeRequestFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopForMeRequestFindByIdRaw(requestParameters: ShopForMeRequestFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeRequestFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async shopForMeRequestFindById(requestParameters: ShopForMeRequestFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopForMeRequestPrototypePatchAttributesRaw(requestParameters: ShopForMeRequestPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeRequestPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopForMeRequests/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShopForMeRequestToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async shopForMeRequestPrototypePatchAttributes(requestParameters: ShopForMeRequestPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin sets prices and sends quote to customer (with notifications)
     */
    async shopForMeRequestQuoteRaw(requestParameters: ShopForMeRequestQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling shopForMeRequestQuote().'
            );
        }

        if (requestParameters['totalAmount'] == null) {
            throw new runtime.RequiredError(
                'totalAmount',
                'Required parameter "totalAmount" was null or undefined when calling shopForMeRequestQuote().'
            );
        }

        if (requestParameters['purchasingFee'] == null) {
            throw new runtime.RequiredError(
                'purchasingFee',
                'Required parameter "purchasingFee" was null or undefined when calling shopForMeRequestQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const body: any = {
            requestId: requestParameters['requestId'],
            totalAmount: requestParameters['totalAmount'],
            purchasingFee: requestParameters['purchasingFee'],
        };
        if (requestParameters['adminNotes'] != null) {
            body.adminNotes = requestParameters['adminNotes'];
        }

        const response = await this.request({
            path: `/ShopForMeRequests/quote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: body,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Generate a quote for a shop for me request
     */
    async shopForMeRequestQuote(requestParameters: ShopForMeRequestQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm a quote for a shop for me request
     */
    async shopForMeRequestConfirmQuoteRaw(requestParameters: ShopForMeRequestConfirmQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeRequestConfirmQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeRequests/{id}/confirmQuote`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Confirm a quote for a shop for me request
     */
    async shopForMeRequestConfirmQuote(requestParameters: ShopForMeRequestConfirmQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestConfirmQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload proof of payment for a shop for me request
     */
    async shopForMeRequestUploadProofRaw(requestParameters: ShopForMeRequestUploadProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling shopForMeRequestUploadProof().'
            );
        }

        if (requestParameters['proofOfPayment'] == null) {
            throw new runtime.RequiredError(
                'proofOfPayment',
                'Required parameter "proofOfPayment" was null or undefined when calling shopForMeRequestUploadProof().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ShopForMeRequests/{id}/uploadProof`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: { proofOfPayment: requestParameters['proofOfPayment'] },
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Upload proof of payment for a shop for me request
     */
    async shopForMeRequestUploadProof(requestParameters: ShopForMeRequestUploadProofRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestUploadProofRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin updates request status with notifications (WhatsApp, email, push)
     */
    async shopForMeRequestUpdateStatusRaw(requestParameters: ShopForMeRequestUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopForMeRequest>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling shopForMeRequestUpdateStatus().'
            );
        }

        if (requestParameters['status'] == null) {
            throw new runtime.RequiredError(
                'status',
                'Required parameter "status" was null or undefined when calling shopForMeRequestUpdateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const body: any = {
            requestId: requestParameters['requestId'],
            status: requestParameters['status'],
        };
        if (requestParameters['packageId'] != null) {
            body.packageId = requestParameters['packageId'];
        }
        if (requestParameters['adminNotes'] != null) {
            body.adminNotes = requestParameters['adminNotes'];
        }

        const response = await this.request({
            path: `/ShopForMeRequests/update-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: body,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopForMeRequestFromJSON(jsonValue));
    }

    /**
     * Update status of a shop for me request
     */
    async shopForMeRequestUpdateStatus(requestParameters: ShopForMeRequestUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopForMeRequest> {
        const response = await this.shopForMeRequestUpdateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send payment link to customer via WhatsApp and email
     */
    async shopForMeRequestSendPaymentLinkRaw(requestParameters: ShopForMeRequestSendPaymentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling shopForMeRequestSendPaymentLink().'
            );
        }

        const queryParameters: any = {};

        queryParameters['requestId'] = requestParameters['requestId'];

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ShopForMeRequests/send-payment-link`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<object>(response);
    }

    /**
     * Send payment link to customer via WhatsApp and email
     */
    async shopForMeRequestSendPaymentLink(requestParameters: ShopForMeRequestSendPaymentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.shopForMeRequestSendPaymentLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
